import React from 'react';

import * as S from './styles';

interface IProps {
  /** CSS width. Defaults to filling the available space. */
  width?: string | number;
  /** CSS height. Defaults to a single line of text. */
  height?: string | number;
  /** Override the 4px corner — pass '50%' for an avatar. */
  radius?: string;
  className?: string;
  style?: object;
}

/**
 * Loading placeholder. A skeleton, not a spinner — it holds the shape of the
 * thing that is arriving, so the layout does not jump when it does.
 *
 * Compose rows from it; `Skeleton.Row` lays them out at table-row height.
 */
const Skeleton = ({ width, height, radius, className, style }: IProps) => (
  <S.Bar
    className={className}
    style={{
      width: width ?? '100%',
      height: height ?? 11,
      ...(radius ? { borderRadius: radius } : {}),
      ...style
    }}
  />
);

Skeleton.Row = S.Row;

export default Skeleton;
